import React from "react"
import PropTypes from "prop-types"
import {get, set, isNull} from "lodash"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {twoDecimalPlaces} from "@irati/utils/validation/regex/number"

import withRewardOnChange from "../../withRewardOnChange"

const PROPERTY = "price"

const SalePriceValue = ({reward, product, onChange, ...props}) => {
  const handleChange = (value) => {
    set(product, PROPERTY, value)
    onChange(reward, "products", reward.products)
  }

  const schema = Validation
    .string(null)
    .matches(twoDecimalPlaces, "Must be a number to two decimal places only")
    .test("positive", "Must be a positive number", (value) => value > 0 || isNull(value))

  return <Input
    name={PROPERTY}
    value={get(product, PROPERTY)}
    onChange={handleChange}
    validation={schema}
    {...props}
    id={id(PROPERTY, props)} />
}

SalePriceValue.propTypes = {
  reward: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

SalePriceValue.defaultProps = {
  placeholder: "Amount",
  label: "Product price",
  hideLabel: true,
  id: "salePriceValue"
}

export default withRewardOnChange(SalePriceValue)
